import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/HomePage/Header";
import Footer from "./Components/HomePage/footer";
import HomePage from "./Components/Homepage";
import Cards from "./Components/Cards";
import ProductCategory from "./Components/ProductCategory";
import Contact from "./Components/ContactPage";
import WhatWeDo from "./Components/WhatWeDo";
import AboutUs from "./Components/AboutUs";
import useGA from "./useGA";

function App() {

  useGA();

  return (
    <>
      <Routes>
        <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
        <Route path="/product" element={<><Header /><Cards /><Footer /></>} />
        <Route path="/Category" element={<><Header /><ProductCategory /><Footer /></>} />
        <Route path="/Contact" element={<><Header /><Contact /><Footer /></>} />
        <Route path="/AboutUs" element={<><Header /><AboutUs /><Footer /></>} />
        <Route path="/WhatWeDo" element={<><Header /><WhatWeDo /><Footer /></>} />
      </Routes>
    </>
  );
}

export default App;
